<template>
  <div class="relative">
    <nav class="flex flex-col w-screen z-10">
      <div class="flex flex-row justify-between text-sm md:text-2xl h-16
        w-full mx-0 md:mx-auto bg-white px-0 lg:px-48">
        <router-link to="/" class="flex items-center">
          <img src="../images/Logo.jpg" class="w-40 md:w-64">
        </router-link>
        <div id="nav"
            class="flex w-auto justify-between items-center space-x-2 md:space-x-4">
          <router-link to="/signin" class="mr-2 text-sm px-6 py-6 bg-orange-academy-300 text-white
            uppercase hidden md:block h-full"
            v-if="!authenticated && !$route.fullPath.includes('signin')
            && $route.fullPath !== '/registration'">
              {{ $t('header.login') }}
          </router-link>
          <div class="flex w-0 md:w-full h-full bg-orange-academy-300 items-center mr-6 md:mr-0"
          v-if="authenticated">
            <md-menu md-size="medium" md-align-trigger class="z-10 w-full">
              <md-button md-menu-trigger>
              <div class="flex items-center px-3">
                <span class="text-xs md:text-sm font-medium text-white
                uppercase mr-0 md:mr-3 hidden md:flex">
                {{ user.student ? user.student.firstname : user.name }}</span>
                <img :src="user.urlProfilePhoto ? user.urlProfilePhoto : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png'"
                  class="rounded-full w-7 md:w-8 transform
                  group-hover:scale-105" v-if="!isAdmin">
              </div>
              </md-button>
              <md-menu-content class="bg-white backdrop-filter backdrop-blur-lg
              backdrop-opacity-10 z-10">
                <md-menu-item  @click="goToDashboard" class="hover:bg-beige-academy-100">
                  {{ $t('header.profile') }}
                </md-menu-item>
                <md-menu-item  @click="goTo('messages')" class="hover:bg-beige-academy-100
                flex justify-between w-full items-center">
                    {{ $t('header.messages') }}
                  <span class="rounded-full px-2 py-1 text-xs text-white"
                  v-if="messagesToRead.length>0"
                  :class="isTeacher? 'bg-beige-academy-300' : 'bg-orange-academy-300'">
                    {{ messagesToRead.length }}
                  </span>
                </md-menu-item>
                <md-menu-item  @click="logout" class="hover:bg-beige-academy-100">
                  {{ $t('header.logout') }}</md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
          <notifications-to-read :dashboardPath="dashboardPath" :textColor="textColor"
            v-if="authenticated && $route.fullPath !== '/signin'
            && $route.fullPath !== '/registration'" class="w-1/5 md:w-auto pr-6"
            @open-notification="openNotification($event)"/>
          <button class="ml-4 flex items-center uppercase text-xs md:text-sm pr-4 lg:pr-0"
            @click="$emit('input', !value)">
            <span class="hidden lg:block pr-3">{{ $t('header.menu') }}</span>
            <hamburger-menu-mobile class="z-20"></hamburger-menu-mobile>
          </button>
        </div>
        <!--
        <div
        class="flex flex-row space-x-3 items-center">
          <button
            @click="$router.push({ path: '/messages' }).catch(()=>{})"
            class="mr-2 relative flex items-center" :class="textHoverColor">
            <svg width="25"
              aria-hidden="true" focusable="false" data-prefix="fas" data-icon="comment" class="svg-inline--fa fa-comment fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"></path></svg>
          </button>

          <notifications />

          <button
            class="mr-2 pr-1 relative flex items-center" :class="textHoverColor">
            <svg width="25"
              aria-hidden="true" focusable="false" data-prefix="fas" data-icon="cog" class="svg-inline--fa fa-cog fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"></path></svg>
          </button>

        </div>-->
      </div>

    </nav>
    <modal name="notification" :adaptive="true" :scrollable="true">
      <keep-alive>
        <component :is="componentToOpen" :notification="selectedNotification" />
      </keep-alive>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import Notifications from '@/components/Notifications.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import dayjs from 'dayjs';
import NotificationsToRead from '@/components/graphics/NotificationsToRead.vue';
import HamburgerMenuMobile from '@/components/graphics/HamburgerMenuMobile.vue';
import AcceptNewLessonTime from '@/components/modals/AcceptNewLessonTime.vue';
import StudentRejectsLesson from '@/components/modals/StudentRejectsLesson.vue';

export default {
  props: ['value'],

  components: {
    NotificationsToRead,
    HamburgerMenuMobile,
    AcceptNewLessonTime,
    StudentRejectsLesson,
  },

  data() {
    return {
      componentToOpen: '',
      selectedNotification: null,
    };
  },

  watch: {
    authenticated() {
      if (!this.authenticated) {
        this.setChoosenTimezone(this.localTimezone);
        dayjs.tz.setDefault(this.choosenTimezone);
      }
    },
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      messagesToRead: 'auth/messagesToRead',
      notificationsToRead: 'auth/notificationsToRead',
      isTeacher: 'auth/isTeacher',
      isAdmin: 'auth/isAdmin',
    }),

    containerColors() {
      if (this.user && this.isTeacher) {
        return 'bg-black text-purple-300 h-20 mb-5';
      }
      return 'text-orange-academy-300 h-24';
    },

    textColor() {
      if (this.isTeacher) {
        return 'beige-academy-300';
      }
      return 'orange-academy-300';
    },
  },

  methods: {
    ...mapActions({
      signOut: 'auth/SignOut',
      setChoosenTimezone: 'timezone/setChoosenTimezone',
    }),
    logout() {
      this.signOut().then(() => {
        this.createNotification('info', this.$t('notifications.logout'));
        this.$router.push({ path: '/' }).catch(() => {});
      });
    },

    goTo(path) {
      this.$router.push(this.isTeacher ? `/teacher-dashboard/${path}` : `/student-dashboard/${path}`);
    },

    openNotification(notification) {
      this.selectedNotification = notification;
      this.componentToOpen = notification.component_to_open;
      if (this.componentToOpen) {
        this.$modal.show('notification');
      }
      if (notification.url_to_open) {
        this.$router.push(`/${notification.url_to_open}`);
      }
    },
  },

  mixins: [StreamFunctionsMixin],

};
</script>

<style scoped>
  .rotated {
    transform:scale(-1, 1);
    -ms-transform:scale(-1, 1);
    -webkit-transform:scale(-1, 1);
  }
</style>
